import PropTypes from 'prop-types';
import './badge.css';

/**
 * Badge — inline-пилюля статуса («HOT», «RESERVED», «DELIVERY»).
 *
 * До #1323 атом нёс два несвязанных режима: пилюлю и диагональную ленту
 * 128×128 на углу карточки. Лента — декоративный оверлей, а не бейдж;
 * вынесена в отдельный `<CardRibbon>` (`card-ribbon.jsx`). Проп `type`
 * убран: у бейджа остался один режим.
 *
 * @param {'hot' | 'sold' | 'delivery'} props.variant — семантика статуса
 */
const Badge = ({ children, variant, className = '' }) => (
  <span className={`badge badge--inline badge--${variant} ${className}`.trim()}>
    {children}
  </span>
);

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['hot', 'sold', 'delivery']).isRequired,
  className: PropTypes.string,
};

export { Badge };
export default Badge;
